module.exports = __webpack_public_path__ + "static/media/TOM_WAGNER_CV.79394ad7.pdf";